import React from 'react';
import Main from './route.js';
import './assets/stylesheets/template.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => <Main />;

export default App;
